import HttpRequest from "@/api/unions_axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
		sendCode(data){
			return axios.request({
			    url: "zgh/site-apply/send-code",
			    method: "get",
			    params: data,
			});
		},
		
		mobileLogin(data){
			return axios.request({
			    url: "zgh/site-apply/verify-code",
			    method: "get",
			    params: data,
			});
		},
		
		submitFirstUnionsData(data){
			return axios.request({
			    url: "zgh/site-apply/apply-one",
			    method: "get",
			    params: data,
			});
		},
		submitSecondUnionsData(data){
			return axios.request({
			    url: "zgh/site-apply/apply-two",
			    method: "get",
			    params: data,
			});
		},
		
		getConfigData1(data){
			return axios.request({
			    url: "zgh/site-apply/common-config-list",
			    method: "get",
			    params: data,
			});
		},
		
		getConfigData2(data){
			return axios.request({
			    url: "zgh/site-apply/industry-list",
			    method: "get",
			    params: data,
			});
		},
		
		getConfigUnions(data){
			return axios.request({
			    url: "zgh/site-apply/organize-list",
			    method: "get",
			    params: data,
			});
		},
		
		addUnions(data){
			return axios.request({
			    url: "zgh/site-apply/organize-add",
			    method: "get",
			    params: data,
			});
		},
		
		getList(data){
			return axios.request({
			    url: "zgh/site-apply/apply-list",
			    method: "get",
			    params: data,
			});
		},
		
		getDetail(data){
			return axios.request({
			    url: "zgh/site-apply/apply-info",
			    method: "get",
			    params: data,
			});
		},
		
		getDataList(data){
			return axios.request({
			    url: "zgh/site-apply/data-list",
			    method: "get",
			    params: data,
			});
		},
		
		getQCCData(data){
			return axios.request({
			    url: "zgh/site-apply/qi-cha-cha",
			    method: "get",
			    params: data,
			});
		},
		
		getRankData(data){
			return axios.request({
			    url: "zgh/activity/qust-rank",
			    method: "get",
			    params: data,
			});
		},
	
    
		
		
}